import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  salesChannelFromModel,
  validateSalesChannelCondition,
  type SalesChannelState,
} from "@redotech/redo-model/return-flow/condition-validate";
import { titleCase } from "@redotech/web-util/strings";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const SALES_CHANNEL = (
  Details: React.ComponentType<ConditionTypeDetailsProps<SalesChannelState>>,
): ConditionType<SalesChannelState, Condition.SalesChannel> => ({
  name: "Sales channel",
  description(state) {
    const formattedChannels = state.map((string: string) => titleCase(string));
    return `Sales channels: ${formattedChannels.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<SalesChannelState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: Condition.SalesChannel) {
    return salesChannelFromModel(model);
  },
  toModel(state) {
    return { type: Condition.SALES_CHANNEL, channels: state };
  },
  valid(state) {
    return validateSalesChannelCondition(state).valid;
  },
});

export { type SalesChannelState } from "@redotech/redo-model/return-flow/condition-validate";
